import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import AdminNav from "./components/AdminNav/AdminNav";
import Loader from "./components/Loader/Loader";
import AuthCallback from "./pages/AuthCallback/AuthCallback";
import SignIn from "./pages/SignIn/SignIn";
import Teams from "./pages/Teams/Teams";
import TeamDetail from "./pages/TeamDetail/TeamDetail";
import Operations from "./pages/Operations/Operations";
import Activity from "./pages/Activity/Activity";

function Gate() {
  const { user, loading, isMentor, isSuperAdmin } = useAuth();

  if (loading) return <Loader />;
  if (!user) return <SignIn />;

  if (!isMentor) {
    return (
      <div className="admin-shell">
        <AdminNav />
        <main className="admin-main">
          <p className="t-body">
            This account is neither a mentor nor a super admin. Ask an
            organiser to grant access.
          </p>
        </main>
      </div>
    );
  }

  return (
    <div className="admin-shell">
      <AdminNav />
      <main className="admin-main">
        <Routes>
          <Route path="/" element={<Teams />} />
          <Route path="/team/:teamId" element={<TeamDetail />} />
          <Route
            path="/ops"
            element={isSuperAdmin ? <Operations /> : <Navigate to="/" replace />}
          />
          <Route
            path="/activity"
            element={isSuperAdmin ? <Activity /> : <Navigate to="/" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/googleToken" element={<AuthCallback />} />
          <Route path="*" element={<Gate />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
